import 'react-calendar/dist/Calendar.css';
import Checkboxes from "./checkboxes";
import { cloneElement, useCallback, useEffect, useRef, useState } from "react";
import DateManipulator from './date-manipulator';
import dayjs from "dayjs";
import { useAppState } from '../../providers/app-state';
import SkgCalendar from "./calendar";
import Timeslots from "./timeslots";
import useAvailabilities from "../../services/availabilities";
import ClosestShops from "./closest-shops";
import "dayjs/locale/da";
import { date_step_heading, date_step_scroll_to_close_shops, date_step_secondary_heading_part_one, date_step_secondary_heading_part_two } from '../../lang/da';
import { useParams } from 'react-router-dom';
import { useHttp } from '../../providers/http';
import ConsentInfoBlock from '../../components/consent-info-block';

const DateScreen = ({ goNext, openSidebar, scrollTo, existing = false }) => {
    const { state, dispatch } = useAppState();
    const { data, isLoading, error } = useAvailabilities(state.selectedShop.id);
    const [closestShops, setClosestShops] = useState([]);
    const [disabledDates, setDisabledDates] = useState([]);
    const scrollContainer = useRef();

    if (error) {
        throw new Error("Fejl med availabilities")
    }

    const onClickClosestShop = useCallback(shop => {
        dispatch({
            key: "selectedShop",
            value: shop
        })
    }, [dispatch])

    useEffect(() => {
        if (!data) return;
        const active = [];
        const disabled = [];
        data.availabilities.forEach(a => {
            if (
                a.closed ||
                DateManipulator.isDatePast(a.date)
            ) {
                return disabled.push(a);
            }
            active.push(a)
        })
        setClosestShops(data.closestShops);
        setDisabledDates(disabled);
        dispatch({
            key: "selectedDate",
            value: dayjs(active[0].date)
        })
    }, [data, dispatch])

    return (
        <div
            className="flex flex-row flex-wrap space-y-6 py-12 md:py-20"
        >
            <div
                className="space-y-5"
            >
                <h1
                    className="text-3xl md:text-4xl font-light"
                >
                    {
                        date_step_heading
                    }
                </h1>
                <div>
                    <p className="font-light">
                        {
                            date_step_secondary_heading_part_one + " "
                        }
                        <span className="font-medium">
                            {state.selectedShop.name}
                        </span>
                    </p>
                    <p className="font-light">
                        {
                            date_step_secondary_heading_part_two
                        }
                    </p>
                </div>
                <div>
                    <button
                        className="underline underline-offset-4 text-skgRed cursor-pointer font-light"
                        onClick={() => {
                            scrollTo(scrollContainer.current.offsetTop)
                        }}
                    >
                        {
                            date_step_scroll_to_close_shops
                        }
                    </button>
                </div>
            </div>
            <div
                className="basis-full"
            >
                <Checkboxes
                    openSidebar={openSidebar}
                />
            </div>
            <div
                className="flex flex-col md:flex-row basis-full flex-wrap md:flex-nowrap md:space-x-6 space-y-6 md:space-y-0"
            >
                <div
                    className="flex-1 p-0.5"
                >
                    <SkgCalendar
                        disabledDates={disabledDates}
                        loading={!state.selectedDate || !disabledDates || isLoading}
                    />
                </div>
                <div
                    className="flex-1 p-0.5"
                >
                    <Timeslots
                        goNext={goNext}
                        loading={!state.selectedDate || !disabledDates || isLoading}
                        openSidebar={openSidebar}
                    />
                </div>
            </div>
            {
                !existing && (
                    <div
                        ref={scrollContainer}
                        className="basis-full md:basis-3/4"
                    >
                        <ClosestShops
                            closestShops={closestShops}
                            onClick={onClickClosestShop}
                        />
                    </div>
                )
            }
            <div
                className="basis-full"
            >
                <ConsentInfoBlock />
            </div>
        </div>
    )
}


//wrapper to to be used with existing offers. Sets the needed data from the previous screens.
export const withExistingOffer = Component => ({ ...props }) => {
    const http = useHttp();
    const { orderId, shopId, plate } = useParams();
    const { dispatch, dispatchMultiple } = useAppState();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        http.get("/shops/" + shopId)
            .then(({ data }) => {

                dispatchMultiple([
                    {
                        key: "selectedShop",
                        value: data
                    },
                    {
                        key: "plate",
                        value: plate
                    }
                ])
            })
            .finally(() => {
                setLoaded(true)
            })
    }, [])

    if (!loaded) return (
        <h1>fffffff</h1>
    )

    return <Component {...props} existing={true} />
}


export default DateScreen;